import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';

const icons = {
  'dicom': '/assets/icons/dicom.svg',
  'google-chrome': '/assets/icons/google-chrome.svg',
  'grouped': '/assets/icons/grouped.svg',
  'info': '/assets/icons/info.svg',
  'jupyter': '/assets/icons/jupyter.svg',
  'ldap': '/assets/icons/ldap.svg',
  'linux': '/assets/icons/linux.svg',
  'mac': '/assets/icons/mac.svg',
  'sort-by-alpha-desc': '/assets/icons/sort-by-alpha-desc.svg',
  'windows': '/assets/icons/windows.svg',
};

@Injectable({ providedIn: 'root' })
export class IconService {
  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
  ) {
    for (const [name, source] of Object.entries(icons)) {
      this.iconRegistry.addSvgIcon(
        name,
        this.sanitizer.bypassSecurityTrustResourceUrl(source)
      );
    }
  }
}

// Is your test failing with `Error: Cannot make XHRs from within a fake async test. Request URL: /assets/icons`?
// If so, you just need to add HttpClientTestingModule to your providers in the test spec file.